'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mostRecentThread = undefined;

var _reselect = require('reselect');

var _getMostRecentOpenThread = require('./getMostRecentOpenThread');

var _getMostRecentTargetedMessageThread = require('./getMostRecentTargetedMessageThread');

var mostRecentThread = exports.mostRecentThread = (0, _reselect.createSelector)([_getMostRecentOpenThread.getMostRecentOpenThread, _getMostRecentTargetedMessageThread.getMostRecentTargetedMessageThread], function (mostRecentOpenThread, mostRecentTargetedMessageThread) {
  return mostRecentOpenThread || mostRecentTargetedMessageThread;
});


//////////////////
// WEBPACK FOOTER
// ./js/threads/selectors/mostRecentThread.js
// module id = 964
// module chunks = 2 3